export default __webpack_public_path__ + "static/media/1947.1d6216f3.png";